import { GET_ONBOARDING_DATA_PATH, SAVE_ONBOARDING_DATA_PATH } from "constants/apiUrls";
import { get, post } from "utils/requests";

export const getOnboardingDataApi = () => get(GET_ONBOARDING_DATA_PATH);
export const saveOnboardingDataApi = params => post(SAVE_ONBOARDING_DATA_PATH, params);
